import classNames from 'classnames';

interface ReportButtonProps {
  icon: React.ComponentType<{ className?: string }>;
  text: string;
  onClick?: (e: React.MouseEvent) => void;
  textClassName?: string;
  dark?: boolean;
}

const ReportButton: React.FC<ReportButtonProps> = ({ icon: Icon, text, onClick, textClassName, dark }) => {
  return (
    <div
      className={classNames(
        'item px-lg-4 group/item pointer-events-auto m-0.5 flex items-center rounded-full transition-all',
        onClick && 'cursor-pointer',
        dark ? 'bg-black/75' : 'bg-white/75',
      )}
      onClick={onClick}
    >
      <div
        className={classNames(
          'flex h-[34px] w-[34px] items-center justify-center rounded-full p-1',
          dark ? 'bg-black' : 'bg-white',
        )}
      >
        <Icon className={classNames('h-5 w-5', dark && 'fill-white')} />
      </div>
      <div className="max-w-0 overflow-hidden transition-all duration-700 group-hover/item:max-w-[120px]">
        <span className={classNames('px-2 text-sm font-medium whitespace-nowrap', dark && 'text-white', textClassName)}>
          {text}
        </span>
      </div>
    </div>
  );
};

export default ReportButton;
